import { getRelayConnectionInitialStep, getRelayConnectionModalParams } from "components/modal/relayConnection";
import { organizationRegistrationStatusesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import React, { useEffect, useState } from "react";
import { closeRelayConnectionNeedAlert } from "sources/relays";

const isBannerPath = (pathname) =>
    pathname === paths.root ||
    pathname.startsWith(`${paths.bid}/`) ||
    pathname.startsWith(`${paths.distributionBids}/`);

const RelayConnectionBanner = ({ organization, roles, location, modal, getOrg }) => {
    const [isHidden, setIsHidden] = useState(false);
    const relay = organization?.relay ?? {};
    const showConnectionNeedAlert = relay.showConnectionNeedAlert;

    useEffect(() => {
        if (showConnectionNeedAlert) {
            setIsHidden(false);
        }
    }, [showConnectionNeedAlert]);

    if (
        isHidden ||
        !showConnectionNeedAlert ||
        !roles?.isTruckingOrganizationAdmin ||
        organization?.registrationStatus !== organizationRegistrationStatusesEnum.Completed ||
        !isBannerPath(location?.pathname ?? "")
    ) {
        return null;
    }

    const closeBanner = (event) => {
        event.stopPropagation();
        ymEvent("RelayConnectionBannerClosed");
        setIsHidden(true);

        closeRelayConnectionNeedAlert().then((res) => {
            if (res && getOrg) {
                getOrg();
            }
        });
    };

    const openModal = () => {
        ymEvent("RelayConnectionBannerClicked");
        modal(
            getRelayConnectionModalParams(getOrg, {
                initialStep: getRelayConnectionInitialStep(relay),
                source: "banner",
            }),
        );
    };

    return (
        <div className="map__relay-banner">
            <div className="map__relay-banner-icon">
                <i className="icon-uEA11-place-holder" />
            </div>
            <div className="map__relay-banner-content">
                <div className="map__relay-banner-title">
                    Вы не видите свой транспорт. Подключите систему мониторинга
                </div>
                <div className="map__relay-banner-text">
                    Следите за движением транспорта, контролируйте свой руб/км и будьте в курсе нештатных ситуаций
                </div>
                <button className="map__relay-banner-button" type="button" onClick={openModal}>
                    <span>Подключить мониторинг</span>
                    <svg
                        width="14"
                        height="12"
                        viewBox="0 0 14 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path
                            d="M1 6H13M13 6L8 1M13 6L8 11"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </div>
            <button className="map__relay-banner-close" type="button" onClick={closeBanner} aria-label="Закрыть">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1 1L11 11M11 1L1 11"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
        </div>
    );
};

export default RelayConnectionBanner;
